import { FormikCheckbox } from '../../../../cdl/Checkbox/FormikCheckbox';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';

export const FormikVesselAdminSection = () => {
    return (
        <div>
            <Text variant="subtitle1">{translate('vessel.form.adminSettings')}</Text>

            <Box display="grid" gap={8} marginTop={16}>
                <FormikCheckbox name="active" label={translate('vessel.form.activeVessel')} />
                <FormikCheckbox name="paying" label={translate('vessel.form.payingVessel')} />
                <FormikCheckbox name="directOrderAllowed" label={translate('vessel.form.directOrder')} />
            </Box>
        </div>
    );
};
